import React from 'react';
import ServicesChartsDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../Common/maps/subtitleMap';
import { QUERY_KEYS_SIH } from '../../../Common/hooks/useChartsData';
import Value from './Value';

const ValueWrapper = () => {
    return (
        <ServicesChartsDataProvider
            subtitlesMap={subtitlesMap}
            queryConfig={{
                key: QUERY_KEYS_SIH.UTI_VALUE,
                url: 'governanceroom/dashboard/sihsus/aih/utiValues'
            }}
        >
            <Value />
        </ServicesChartsDataProvider>
    );
};

export default ValueWrapper;
